import React from 'react';
import PropTypes from 'prop-types';
import RequiredReasonTextarea from '../../../util_components/required_reason_textarea';

const reason_placeholder = (edit) => {
  if (edit.status_changed) return 'Reason for status change (required)';
  if (edit.attribution_changed) return 'Reason for changing who cancelled (required)';
  return 'Reason for changing the request time (required)';
};

const reason_error_text = (edit) => {
  const what = edit.status_changed
    ? 'change the session status'
    : edit.attribution_changed
      ? 'change the cancellation attribution'
      : 'change the request time';
  return `A reason (at least 3 characters) is required to ${what}`;
};

// The Edit modal's required note, worded for a status change or a who-cancelled flip; hidden when none is needed.
function EditReasonField({ edit, value, name, onChange, error, label }) {
  if (!edit.show_reason_textarea) return null;
  return (
    <RequiredReasonTextarea
      value={value}
      name={name}
      onChange={onChange}
      placeholder={reason_placeholder(edit)}
      error={error}
      errorText={reason_error_text(edit)}
      label={label}
    />
  );
}

EditReasonField.propTypes = {
  edit: PropTypes.shape({
    show_reason_textarea: PropTypes.bool,
    status_changed: PropTypes.bool,
    attribution_changed: PropTypes.bool
  }).isRequired,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  label: PropTypes.string
};

EditReasonField.defaultProps = {
  value: '',
  error: false,
  label: ''
};

export default EditReasonField;
